import { React, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import Button from "../../commonComponents/Buttons/Button";

import { get_leaderboard_info } from "../../../redux/features/userSlice";

import { useLockBodyScroll } from "../../../hooks";

import "./leaderBoardModal.scss";
import { CoinIcon } from "../../../assets";

function LeaderBoardModal({ setVisibleLeaderboardModal }) {
  useLockBodyScroll();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [leaderBoardInfo, setLeaderBoardInfo] = useState();

  useEffect(() => {
    if (!leaderBoardInfo) {
      dispatch(get_leaderboard_info()).then((result) => {
        setLeaderBoardInfo(result?.payload);
      });
    }
  }, [leaderBoardInfo, dispatch]);

  return (
    <>
      <section className="modalBg">
        <section className="modalBody">
          <div className="dialog-header">
            <h3 className="heading-3">{t("leaderboard")}</h3>
          </div>

          <div className="table-container-leaderBoard">
            <table>
              <thead>
                <tr>
                  <th>&#8470;</th>
                  <th>{t("name")}</th>
                  <th>
                    <span className="coin-icon-title">
                      <img src={CoinIcon} className="coin-icon" alt="Coin" />
                      {t("points")}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {leaderBoardInfo?.top_scores?.map((item) => (
                  <tr>
                    <td>{leaderBoardInfo?.top_scores?.indexOf(item) + 1}</td>
                    <td>{item?.name}</td>
                    <td>{item?.points}</td>
                  </tr>
                ))}
                {leaderBoardInfo?.my_info?.my_rank > 20 && (
                  <tr className="currentUserRow">
                    <td>{leaderBoardInfo?.my_info?.my_rank}</td>
                    <td>{leaderBoardInfo?.my_info?.name}</td>
                    <td>{leaderBoardInfo?.my_info?.points}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="buttons dialog-footer">
            <Button
              label={t("okay")}
              viewType="mainBtn"
              onClick={() => setVisibleLeaderboardModal(false)}
            />
          </div>
          <Button
            iconClassName="hasIcon--close"
            viewType="transparentIcon"
            onClick={() => setVisibleLeaderboardModal(false)}
          />
        </section>
      </section>
    </>
  );
}

export default LeaderBoardModal;
